import React from 'react'
import styles from './EFChip.module.scss'
import classNames from 'classnames/bind'
import { Chip, ChipProps } from '@mui/material'

const cx = classNames.bind(styles)

interface IEFChip {
  type: 'approved' | 'waiting' | 'info'
  children: React.ReactNode
}

export function VersionChip({ type, children }: IEFChip) {
  return <div className={cx('version-chip', type)}> {children}</div>
}

export function StatusChip(props: ChipProps) {
  return (
    <Chip
      {...props}
      className={cx(props.className)}
    />
  )
}
